import {
  FAB_SURGE_GET_USER_SUMMARY,
  FAB_SURGE_GET_USER_SUMMARY_SUCCESS,
  FAB_SURGE_GET_USER_SUMMARY_ERROR,
  FAB_SURGE_GET_USER_SUMMARY_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetFabUserSummary = (state = initialState, action) => {
  switch (action.type) {
    case FAB_SURGE_GET_USER_SUMMARY:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case FAB_SURGE_GET_USER_SUMMARY_SUCCESS:
      console.log('hello action', action.payload);
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case FAB_SURGE_GET_USER_SUMMARY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case FAB_SURGE_GET_USER_SUMMARY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetFabUserSummary;
